import { z } from 'zod';
/**
 * Monitor de supervisão (Etapa 4): o retrato ao vivo de um setor e os comandos que o
 * supervisor dispara dali. Tudo que é tempo aqui vem em segundos já calculados no
 * servidor — o navegador só continua contando a partir de `apuradoEm`, para o relógio
 * da máquina de quem olha não bagunçar o número.
 */
/** Como o monitor pinta a linha: dentro do prazo, quase estourando ou estourado. */
export const SINAL_SLA = ['ok', 'atencao', 'estourado'];
/** A partir de quanto do prazo a linha fica amarela (80% do SLA do setor). */
export const FRACAO_ATENCAO_SLA = 0.8;
export const prioridadeSchema = z.object({ prioritaria: z.boolean() });
export const transferirDoMonitorSchema = z.object({
    atendenteId: z.uuid(),
    motivo: z.string().trim().max(300).optional().or(z.literal('')),
});
export const devolverParaFilaSchema = z.object({
    motivo: z.string().trim().max(300).optional().or(z.literal('')),
});
export const limiteSimultaneoSchema = z.object({
    limite: z.coerce.number().int().min(1).max(50),
});
export const presencaForcadaSchema = z.object({
    status: z.enum(['online', 'pausa', 'offline']),
});
//# sourceMappingURL=supervisao.js.map